//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GroupbyName } from "../../utils/helper";
export default {
  data: function data() {
    return {
      param: {
        username: '',
        password: ''
      },
      rules: {
        username: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }]
      },
      showLogin: false,
      isshow: false,
      screenheight: '',
      name: localStorage.getItem('ms_username'),
      structArr: [],
      balanceArr: [],
      columnNum: 6,
      ishasData: true,
      timer: 0
    };
  },
  filters: {
    formateDu: function formateDu(value) {
      return value;
    }
  },
  created: function created() {
    // this.getData();
    this.getstructArr();
  },
  mounted: function mounted() {
    var _this = this;

    this.timer = setInterval(function () {
      var indexof = (window.location.hash + '').indexOf('ScaleIndex');

      if (indexof >= 0) {
        setTimeout(_this.getstructArr(), 0);
      }
    }, 1000 * 6);
    this.timer = setInterval(function () {
      setTimeout(_this.updateShowLogin(), 0);
    }, 1000);
  },
  methods: {
    setClose: function setClose() {
      localStorage.setItem('showLogin', 'no');
    },
    updateShowLogin: function updateShowLogin() {
      var showL = localStorage.getItem('showLogin');

      if (showL == 'yes') {
        this.showLogin = true;
      } else {
        this.showLogin = false;
      }
    },
    submitForm: function submitForm() {
      var _this2 = this;

      this.$refs.login.validate(function (valid) {
        if (valid) {
          // 跳转登陆
          //var pwd=  DecPwd(this.param.password,this.param.username);
          var pwd = _this2.param.password;

          _this2.$zybhttp.post('Account/SignIn', {
            loginid: _this2.param.username,
            pwd: pwd
          }).then(function (res) {
            if (res.data.status == 0) {
              _this2.$message.success(res.data.msg);

              localStorage.setItem('ms_username', _this2.param.username);
              localStorage.setItem('ms_userInfo', JSON.stringify(res.data.data));
              localStorage.setItem('showLogin', 'no');
              _this2.editVisible = false;

              _this2.$router.go(0);
            } else {
              _this2.$notify.error(res.data.msg);

              return;
            }
          }).catch(function (err) {
            return _this2.$notify.error('网络异常！');
          });
        } else {
          _this2.$message.error('请输入账号和密码');

          console.log('error submit!!');
          return false;
        }
      });
    },
    getData: function getData() {
      this.ishasData = true;
    },
    groupTitle: function groupTitle(items) {
      return '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;总流量:' + items.data[0].TotalSpeed + 't/h&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;占比方式:' + items.data[0].percentType;
    },
    getstructArr: function getstructArr() {
      var _this3 = this;

      this.$zybhttp.get('Business/GetScaleGroupData', {}).then(function (res) {
        if (res.data.status == 0) {
          var data = res.data.data.list; //this.balanceArr = this.balanceArr;

          var dataLength = data.length;

          if (dataLength > 0) {
            _this3.ishasData = true;
          } else {
            _this3.ishasData = false;
          }

          var darr = GroupbyName(data, 'ScaleGroupName');
          _this3.balanceArr = darr;
        } else {
          _this3.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this3.$notify.error('网络异常！获取列表失败！');
      });
    } // setCJHeight() {
    //     this.$nextTick(() => {
    //         // 页面渲染完成后的回调
    //         var headerHeight = document.getElementById('selSensor').offsetHeight + 30;
    //         this.screenheight = document.documentElement.clientHeight * 0.9 - headerHeight + 'px';
    //     });
    // }

  }
};